import * as types from './types';
import _ from 'lodash';

const INITIAL_STATE = {
  licenseAssignSite: {
    Data: [],
    Errors: [],
    Message: [],
    CountErrors: [],
  },
  licenseCount: 0,
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.LICENSEASSIGNSITE_GET:
      return {
        ...state,
        licenseAssignSite: {
          ...state.licenseAssignSite,
          Data: action.payload.data.Data,
          Errors: [],
        },
      };
    case types.LICENSEASSIGNSITE_ERROR:
      return {
        ...state,
        licenseAssignSite: {
          ...state.licenseAssignSite, //preserve Data:
          Errors: action.payload.data.Errors,
        },
      };
    case types.LICENSEASSIGNSITE_UPDATE:
      return {
        ...state,
        licenseAssignSite: {
          ...state.licenseAssignSite,
          Message: action.payload.data.Data,
        },
      };
    case types.LICENSEASSIGNSITE_CLEAR_ERROR:
      return {
        ...state,
        licenseAssignSite: {
          ...state.licenseAssignSite,
          Errors: undefined,
        },
      };
    case types.LICENSEASSIGNSITE_GET_LICENSED_COUNT:
      return { ...state, licenseCount: action.payload.data };
    case types.LICENSEASSIGNSITE_GET_LICENSED_COUNT_ERROR:
      return {
        ...state,
        licenseAssignSite: {
          ...state.licenseAssignSite,
          CountErrors: action.payload.data.Errors,
        },
        licenseCount: 0,
      };
    case types.LICENSEASSIGNSITE_LOADING:
      return { ...state, loading: action.payload };
    case types.LICENSEASSIGNSITE_UPDATE_COLLECTION:
      let newData = state.licenseAssignSite.Data.slice();
      let item = _.find(newData, { Id: action.payload.Id });
      if (item === undefined) {
        return state;
      }
      item.IsLicensed = !action.payload.IsLicensed;
      return {
        ...state,
        licenseAssignSite: {
          ...state.licenseAssignSite,
          Data: newData,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/assignlicense/state/reducer.js